











































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  modalBibliographySearchHistoryStore,
  modalErrorStore
} from '@/utils/store-accessor'
import {
  Alert,
  AlertMessage,
  bibliographyApi,
  BibliographySearchHistory,
  ErrorMessage
} from '@/api'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  SearchHistoryTable,
  SearchHistoryTableItem
} from '@/components/organisms/SearchHistoryTable'
import { AlertFactory } from '@/factory'
import { AlertCodeAL300031, AlertCodeSLC00002 } from '@/types'

@Component({
  components: {
    SearchHistoryTable,
    ModalFooter
  }
})
export default class ModalBibliographySearchHistory extends ModalComponentBaseVue {
  searchHistories: BibliographySearchHistory[] = []

  tableItems: SearchHistoryTableItem[] = []

  tableBodyHeight: number = 0

  get isOpen(): boolean {
    return modalBibliographySearchHistoryStore.isOpen
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      this.getSearchHistories().then(() => {
        if (this.searchHistories.length === 0) {
          this.close()
          const alert: Alert = AlertFactory.create(
            AlertCodeSLC00002,
            '検索履歴'
          )
          alertStore.setItem(alert)
          this.$modalAlert.open()
        }
      })
      this.$nextTick(this.calculateTableHeight)
    }

    this.tableItems = []
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.calculateTableHeight)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  close(): void {
    modalBibliographySearchHistoryStore.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bibliography-search-history')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  async deleteSearchHistories(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyApi.deleteBibliographySearchHistories()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getSearchHistories(): Promise<void> {
    try {
      this.searchHistories = await bibliographyApi.getBibliographySearchHistories()
      this.tableItems = this.createTableItems(this.searchHistories)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  convertStringSearchableNot(value: string): string {
    if (value.endsWith('1')) {
      return value.slice(0, -1)
    }

    return value.replace(/2$/, ' not')
  }

  createTableItems(
    array: BibliographySearchHistory[]
  ): SearchHistoryTableItem[] {
    return array.map((value, index) => {
      let targetItem: any = null

      switch (value.type) {
        case '1':
          targetItem = {
            title1: this.convertStringSearchableNot(value.title1),
            title2: this.convertStringSearchableNot(value.title2),
            titleInformation: value.titleInformation
              ? 'シリーズ、内容、目次含む'
              : '',
            author1: this.convertStringSearchableNot(value.author1),
            author1Id: this.convertStringSearchableNot(value.author1No),
            author2: this.convertStringSearchableNot(value.author2),
            author2Id: this.convertStringSearchableNot(value.author2No),
            authorInformation: value.authorInformation ? '関連情報含む' : '',
            subject1: this.convertStringSearchableNot(value.subject1),
            subject1Id: this.convertStringSearchableNot(value.subject1No),
            subject2: this.convertStringSearchableNot(value.subject2),
            subject2Id: this.convertStringSearchableNot(value.subject2No),
            series: this.convertStringSearchableNot(value.series),
            seriesId: this.convertStringSearchableNot(value.seriesNo),
            completeWorks: this.convertStringSearchableNot(value.completeWorks),
            completeWorksId: this.convertStringSearchableNot(
              value.completeWorksNo
            ),
            notes: value.notes,
            publisher: this.convertStringSearchableNot(value.publisher),
            publisherId: this.convertStringSearchableNot(value.publisherNo),
            volumeLabel: this.convertStringSearchableNot(value.volumeLabel),
            classNo: value.classNo,
            publishedYearFrom: value.publishedYearFrom,
            publishedYearTo: value.publishedYearTo,
            freeWords: value.freeWords,
            playbackTimeFrom: value.playbackTimeFrom,
            playbackTimeTo: value.playbackTimeTo,
            volume: value.volume,
            volumeNumber: value.volumeNumber,
            volumeTotal: value.volumeTotal,
            dateLabel: value.dateLabel,
            genre: value.genre,
            targetUsers: value.targetUsers,
            targetUsersAv: value.targetUsersAv,
            collectionType: value.collectionType,
            shelfType: value.shelfType,
            mark: value.mark,
            ndc: value.ndc,
            book: value.book,
            sub: value.sub,
            traderCode: value.traderCode,
            donorCode: value.donorCode,
            collectionStatus: value.collectionStatus,
            holdingBranchCode: value.holdingBranchCode,
            acceptDateFrom: value.acceptDateFrom,
            acceptDateTo: value.acceptDateTo,
            handlingType: value.handlingType,
            lendTotal: value.lendTotal
              ? value.lendTotalFlag === '1'
                ? `${value.lendTotal}未満`
                : `${value.lendTotal}以上`
              : '',
            lastLendDate: value.lastLendDate
              ? value.lastLendDateFlag === '1'
                ? `${value.lastLendDate}以前`
                : `${value.lastLendDate}以降`
              : '',
            searchTarget: value.searchTarget
          }
          break
        case '2':
          targetItem = {
            newPublicationInformationDate: value.newPublicationInformationDate,
            newPublicationInformationVolume:
              value.newPublicationInformationVolume,
            collectionNo: value.collectionNo,
            exceptCheckDigit: value.exceptCheckDigit ? 'CD除く' : '',
            orderId: value.orderId,
            bibliographyId: value.bibliographyId,
            isbn: value.isbn,
            productNo: value.productNo,
            magazineCode: value.magazineCode,
            marcNo: value.marcNo,
            searchTarget: value.searchTarget
          }
          break
        case '3':
          targetItem = {
            freeWords: value.freeWords,
            classNo: value.classNo,
            collectionType: value.collectionType,
            shelfType: value.shelfType,
            mark: value.mark,
            ndc: value.ndc,
            book: value.book,
            sub: value.sub,
            traderCode: value.traderCode,
            donorCode: value.donorCode,
            collectionStatus: value.collectionStatus,
            holdingBranchCode: value.holdingBranchCode,
            acceptDateFrom: value.acceptDateFrom,
            acceptDateTo: value.acceptDateTo,
            handlingType: value.handlingType,
            lendTotal: value.lendTotal
              ? value.lendTotalFlag === '1'
                ? `${value.lendTotal}未満`
                : `${value.lendTotal}以上`
              : '',
            lastLendDate: value.lastLendDate
              ? value.lastLendDateFlag === '1'
                ? `${value.lastLendDate}以前`
                : `${value.lastLendDate}以降`
              : '',
            searchTarget: value.searchTarget
          }
          break
        case '4':
          targetItem = {
            author1: value.author1,
            author1Id: value.author1No,
            subject1: value.subject1,
            subject1Id: value.subject1No,
            series: value.series,
            seriesId: value.seriesNo,
            completeWorks: value.completeWorks,
            completeWorksId: value.completeWorksNo,
            contentTitle: value.contentTitle,
            contentAuthor: value.contentAuthor,
            contentAuthorId: value.contentAuthorNo,
            publisher: value.publisher,
            publisherId: value.publisherNo,
            searchTarget: value.searchTarget
          }
          break
        case '5':
          targetItem = {
            title1: this.convertStringSearchableNot(value.title1),
            contentTitle: this.convertStringSearchableNot(value.contentTitle),
            contentAuthor: this.convertStringSearchableNot(value.contentAuthor),
            contentAuthorId: this.convertStringSearchableNot(
              value.contentAuthorNo
            ),
            searchTarget: value.searchTarget
          }
          break
      }

      const targetArray: any[] = Object.entries(targetItem)

      const item1 = targetArray.find((value: any) => value[1])
      const item2 = targetArray.find(
        (value: any) => value[1] && item1 && value[0] !== item1[0]
      )

      return {
        id: value.id,
        isSelected: index === 0,
        searchType: value.type,
        item1: item1 ? item1[0] : '',
        key1: item1 ? item1[1] : '',
        item2: item2 ? item2[0] : '',
        key2: item2 ? item2[1] : ''
      }
    })
  }

  onClickCancel(): void {
    modalBibliographySearchHistoryStore.cancel()
  }

  onClickDelete(): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL300031, '検索履歴')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.deleteSearchHistories()
        modalBibliographySearchHistoryStore.delete()
      }
    })
  }

  onClickExecution(): void {
    const selectedItem = this.searchHistories.find(history =>
      this.tableItems.some(item => history.id === item.id && item.isSelected)
    )
    if (selectedItem !== undefined) {
      modalBibliographySearchHistoryStore.execution(selectedItem)
    }
  }

  onClickLoading(): void {
    const selectedItem = this.searchHistories.find(history =>
      this.tableItems.some(item => history.id === item.id && item.isSelected)
    )
    if (selectedItem !== undefined) {
      modalBibliographySearchHistoryStore.loading(selectedItem)
    }
  }
}
